import React, { useEffect, useState } from "react";
import { Grid, Typography, makeStyles } from "@material-ui/core";
import { adminService } from "../../../../services/index";
import { useSelector } from "react-redux";
import { Skeleton } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  whiteColor: {
    color: theme.palette.eWhite.base,
  },
}));

export default function PaymentTerms({ quickpayData }) {
  let classes = useStyles();
  let [finalContent, setFinalContent] = useState();
  useEffect(() => {
    if (quickpayData) {
      let contents = [quickpayData("E_QUICK_PAY_PAYMENT_TERMS").answer.split("***")[0]];
          setFinalContent(contents);
        }
  }, [quickpayData])


  return (
    <Grid container spacing={1} >
      <Grid item xs={12}>
        <Typography variant="subtitle1" className={classes.whiteColor}>
          {
            quickpayData ? <b>{quickpayData("E_QUICK_PAY_PAYMENT_TERMS").question}</b> : <Skeleton variant="rectangular" animation="wave" />
          }
        </Typography>
      </Grid>
      {finalContent ? (
        finalContent.map((i) => {
          return (
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={1}>
                  <span className={classes.whiteColor}>
                    <b>&gt;</b>
                  </span>
                </Grid>
                <Grid item xs={11}>
                  <Typography variant="subtitle2" className={classes.whiteColor}>{i}</Typography>
                </Grid>
              </Grid>
            </Grid>
          );
        })
      ) : (
        <Grid item xs={12}>
          <Skeleton variant="rectangular" animation="wave" />
          <Skeleton variant="rectangular" animation="wave" />
          <Skeleton variant="rectangular" animation="wave" />
        </Grid>
      )
      }
    </Grid>
  );
}
